// Vendors
import Vue from 'vue';
import ShardsVue from 'shards-vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import VueSweetalert2 from 'vue-sweetalert2';
import DOMPurify from 'dompurify';
import 'sweetalert2/dist/sweetalert2.all.min.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import vSelect from 'vue-select';
import { mask } from 'vue-the-mask';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.override.scss';
import '@/assets/scss/tabs-validation.scss';
import 'vue-select/dist/vue-select.css';
import '@/assets/scss/vue-select.override.scss';

// Core
import App from './App.vue';
import AppConfig from './.env';
import router from './router';
import store from './store/index';
import SanitizeUtils from './utils/SanitizeUtils';

// Layouts
import Default from '@/layouts/Default.vue';
import DriverLayout from '@/layouts/Driver.vue';
import GuestLayout from '@/layouts/Guest.vue';
import WorkerLayout from '@/layouts/Worker.vue';

// Helpers
import addVeeValidateRules from '@/utils/VeeValidateRules.js';

// Custom components
import FileInput from '@/components/common/FileInput.vue';

// Global components
Vue.component('guest-layout', GuestLayout);
Vue.component('worker-layout', WorkerLayout);
Vue.component('driver-layout', DriverLayout);
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.component('v-select', vSelect);
Vue.component('file-input', FileInput);

// Global directives
Vue.directive('mask', mask);

// Configure vendors
addVeeValidateRules(extend);

// Axios
window.axios = Axios;
Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.baseURL = AppConfig.apiServerUrl;

if (SanitizeUtils.getToken()) {
  Vue.prototype.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
  Vue.prototype.$http.defaults.headers['Cache-Control'] = 'no-store,max-age=0';
}

Vue.prototype.$http.interceptors.response.use(undefined, (error) => {
  if (error.response.status === 401 && router.currentRoute.path !== '/logowanie') {
    window.localStorage.setItem('token', '');
    window.location.reload();
  }

  return Promise.reject(error);
});

// Shards
ShardsVue.install(Vue);
Vue.component('default-layout', Default);
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();

// Other
Vue.use(VueAxios, Axios);
Vue.use(VueSweetalert2);

// DOMPurify configuration
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }

  // set non-HTML/MathML links to xlink:show=new
  if (!node.hasAttribute('target') && (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
    node.setAttribute('xlink:show', 'new');
  }
});

// Register v-pure-html directive
Vue.directive('pure-html', {
  inserted: (el, binding) => {
    if (binding.oldValue === binding.value) {
      return;
    }
    el.innerHTML = DOMPurify.sanitize(binding.value);
  },
  update: (el, binding) => {
    if (binding.oldValue === binding.value) {
      return;
    }
    el.innerHTML = DOMPurify.sanitize(binding.value);
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
